import { Stack } from '@mui/material';
import styled from '@mui/system/styled';
import CustomModal from 'components/CustomModal';

export const CustomModalWrapper = styled(CustomModal, {
  shouldForwardProp: (prop) => prop !== 'smallScreen',
})(({ smallScreen }) => ({
  '& .MuiPaper-root': {
    borderRadius: smallScreen ? 'unset' : '24px',
    width: 900,
    height: 600,
    maxWidth: 'unset',
    margin: 0,
    maxHeight: 'unset',
  },
}));

export const ContentWrapper = styled(Stack)({
  overflow: 'auto',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',

  '& .header': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: 18,
    borderBottom: '1px solid #E0E0E0',
    '& .title': {
      fontWeight: 800,
      fontSize: 20,
      lineHeight: '100%',
      color: 'rgba(0, 0, 0, 1)',
    },
  },

  '& .content': {
    marginTop: 33,
  },

  '& .statement': {
    fontWeight: 600,
    fontSize: 13,
    lineHeight: '22.4px',
    color: '#212121',
  },
});
